module.exports = __webpack_public_path__ + "static/media/pdf_icon.e57dc3fa.png";